export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Успех"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ошибка"])}
}